
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/franchising",
      function () {
        return require("private-next-pages/franchising.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/franchising"])
      });
    }
  